import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { doTokenLoginRequestExternalToken } from "../../store/modules/qrCode/actions";

export default function Token(props) {
	const dispatch = useDispatch();

	useEffect(() => {
		let token = props.match.params.token;
		if (token) {
			dispatch(doTokenLoginRequestExternalToken(token));
		}
		// eslint-disable-next-line
	}, []);

	return <div>_</div>;
}
